export enum QuotationMode {
  Unknown = 0,
  Detailed = 1,
  Fast = 2,
}
